module.exports = __webpack_public_path__ + "img/audi.84baa28e.jpg";